import { render, staticRenderFns } from "./ResourceQuestion.vue?vue&type=template&id=f4edbd56&"
import script from "./ResourceQuestion.vue?vue&type=script&lang=js&"
export * from "./ResourceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports